/**
* DevExpress Dashboard (_create-query-page.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { getFederationFieldList } from '../_helpers';
import { ParametersItemProvider } from './_parameters-item-provider';
export function createQueryPageCallback(requestWrapper, parameters, dataSourceBrowser, customQueriesPreset = undefined) {
    return {
        customQueriesPreset: customQueriesPreset,
        customizeQBInitData: (initData) => {
            initData.parametersItemsProvider = new ParametersItemProvider(parameters());
            initData.requestWrapper = requestWrapper;
            return initData;
        },
        selectStatement: (connection, query) => requestWrapper.getSelectStatement(connection, query),
        getItemsProviderCallback: () => new ParametersItemProvider(parameters()),
        fieldListsCallback: (pathRequest, dataSourceInfo) => getFederationFieldList(pathRequest, dataSourceBrowser),
    };
}
